/* eslint-disable default-case, react/no-danger */
import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Checkbox, FileUploader, Input, Select } from '@beef/ui-kit';
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
export var InputItem = /*#__PURE__*/memo(function (_ref) {
  var item = _ref.item,
    value = _ref.value,
    _onChange = _ref.onChange,
    error = _ref.error,
    isSuccessSending = _ref.isSuccessSending;
  var input = null;
  var handleChangeText = function handleChangeText(e) {
    _onChange(item.key, e.target.value);
  };
  switch (item.type) {
    case 'text':
      input = /*#__PURE__*/React.createElement(Input, {
        errorMessage: error,
        name: item.key,
        onChange: handleChangeText,
        placeholder: item.placeholder,
        type: "text",
        value: value,
        "data-t-id": "Components-InputItem"
      });
      break;
    case 'email':
      input = /*#__PURE__*/React.createElement(Input, {
        errorMessage: error,
        name: item.key,
        onChange: handleChangeText,
        placeholder: item.placeholder,
        type: "email",
        value: value
      });
      break;
    case 'phone':
      input = /*#__PURE__*/React.createElement(Input, {
        errorMessage: error,
        maskSettings: {
          mask: '_',
          format: '+7 ### ###-##-##'
        },
        name: item.key,
        onChange: handleChangeText,
        placeholder: item.placeholder,
        type: "tel",
        value: value
      });
      break;
    case 'textarea':
      input = /*#__PURE__*/React.createElement(Input, {
        errorMessage: error,
        isTextArea: true,
        isTextAreaResizable: true,
        name: item.key,
        onChange: handleChangeText,
        placeholder: item.placeholder,
        type: "text",
        value: value
      });
      break;
    case 'select':
      input = /*#__PURE__*/React.createElement(Select, {
        errorMessage: error,
        onChange: function onChange(newValue) {
          _onChange(item.key, newValue);
        },
        options: item.options.map(function (option) {
          return {
            label: option,
            id: option
          };
        }),
        value: value
      });
      break;
    case 'file':
      input = /*#__PURE__*/React.createElement(FileUploader, {
        allowedTypes: item.allowedTypes,
        errorMessage: error
        // для ресета после успешной отправки
        ,
        isSuccessSending: isSuccessSending,
        maxFileSize: item.maxFileSize,
        maxFiles: item.countFiles,
        multiple: true,
        onChange: function onChange(files) {
          if (files.length === 0) {
            _onChange(item.key, undefined);
          } else {
            // приводим к типу File возможно стоит заменить на нативный File
            var validFiles = files.map(function (file) {
              return file.file;
            }).filter(function (file) {
              return file !== undefined;
            });
            _onChange(item.key, validFiles.length > 0 ? validFiles : undefined);
          }
        }
      });
      break;
    case 'checkbox':
      input = /*#__PURE__*/React.createElement(Checkbox, {
        checked: !!value,
        isError: !!error,
        name: item.key,
        onChange: function onChange(e) {
          return _onChange(item.key, e.currentTarget.checked);
        },
        rightSideNode: /*#__PURE__*/React.createElement("span", {
          className: cn('checkbox_text'),
          dangerouslySetInnerHTML: {
            __html: item.name
          }
        })
      });
      break;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cn('item', {
      'item--cb': item.type === 'checkbox'
    })
  }, item.type === 'checkbox' ? input : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cn('title')
  }, item.name), input));
});